import React, { useEffect, useState } from "react";
import ListWallet from "../../components/ListWallet";
import { callAPI } from "../../utils";

export default function Xendit(props) {
  const [listChannels, setListChannels] = useState(null);
  const { setIsLoading, userId, userType, fleetToken, tranId, orderId, gateway } =
    props;
  const walletOrderId = tranId ?? orderId;

  useEffect(() => {
    async function fetchData() {
      const data = await callAPI(
        `${process.env.REACT_APP_WEBHOOK_API_ENDPOINT}/api/webhook/getWalletChannels`,
        "POST",
        {
          fleetToken,
          userId,
          userType,
          orderId: walletOrderId,
          gateway,
        }
      );
      if (data.response.redirect) {
        window.location.href = data.response.returnWebUrl;
      } else {
        setListChannels(data.response.listChannels);
        setIsLoading(false);
      }
    }
    if (listChannels == null) {
      fetchData();
    }
  }, [
    listChannels,
    fleetToken,
    userId,
    userType,
    walletOrderId,
    setIsLoading,
    gateway,
  ]);

  const onSubmit = async (item) => {
    setIsLoading(true);
    const data = await callAPI(
      `${process.env.REACT_APP_WEBHOOK_API_ENDPOINT}/api/webhook/processPaymentWithXendit`,
      "POST",
      {
        fleetToken,
        orderId: walletOrderId,
        channel: item.channel,
        code: item.code,
        gateway: item.gateway,
      }
    );
    if (data.returnCode === 200 && data.response) {
      window.location.href = data.response["3ds_url"];
    }
    setIsLoading(false);
  };

  return (
    <div>
      {listChannels != null ? (
        <ListWallet onSubmit={onSubmit} listChannels={listChannels} />
      ) : null}
    </div>
  );
}
